/* Fun, free product discovery; only navigates to available products. */
(() => {
  'use strict';
  if (window.jbDiscoverInstalled) return;
  window.jbDiscoverInstalled = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-jb-discover-random]');
    if (!button) return;
    const section = button.closest('.jb-discover');
    if (!section) return;
    let links = [];
    try {
      links = JSON.parse(section.querySelector('[data-jb-discover-products]')?.textContent || '[]');
    } catch (_) {}
    if (!Array.isArray(links) || !links.length) {
      window.location.assign('/collections/best-sellers');
      return;
    }
    const selected = links[Math.floor(Math.random() * links.length)];
    if (typeof selected === 'string' && selected.startsWith('/products/')) {
      window.location.assign(selected);
    } else {
      window.location.assign('/collections/weekly-sale-picks');
    }
  });
})();
